import React, { useState, useEffect } from 'react';
import { collection, getDocs, orderBy, query, limit } from 'firebase/firestore';
import { db } from '../firebase-config';

const Announcements = () =>
{
  const [announcements, setAnnouncements] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() =>
  {
    const fetchAnnouncements = async () =>
    {
      try
      {
        const q = query(
          collection(db, 'Announcements'),
          orderBy("AnnouncedAt", "desc"),
          limit(10)
        );

        const snapshot = await getDocs(q);
        const announcementPosts = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setAnnouncements(announcementPosts);
      }
      catch (err)
      {
        console.error('Failed to fetch announcements:', err);
      }
      finally
      {
        setIsLoading(false);
      }
    };

    fetchAnnouncements();
  }, []);

  return (
    <div className="bg-white dark:bg-gray-900 px-2">

      {/* SECTION HEADER */}
      <h2
        className="
          text-xl
          sm:text-2xl
          lg:text-3xl
          font-bold
          mb-3
          text-black
          dark:text-white
        "
      >
        <span className="text-red-600 animate-pulse">L</span>atest Announcements
      </h2>

      {/* CONTENT */}
      {
        isLoading ? (
          <div className="text-center text-base sm:text-xl font-medium text-gray-400">
            Loading announcements...
          </div>
        ) : announcements.length > 0 ? (
          <div className="space-y-2 sm:space-y-6">
            {announcements.map((announcement) => (
              <div
                key={announcement.id}
                className="bg-gray-900 rounded-xl shadow-md p-4 sm:p-6 border border-white"
              >
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 mb-2">
                  <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-white break-words">
                    {announcement.title}
                  </h3>

                  <span className="text-xs sm:text-sm font-bold px-3 py-1 rounded-full bg-blue-600 text-white w-fit">
                    Announcement
                  </span>
                </div>

                <p className="text-sm sm:text-md text-gray-300 mb-3 sm:mb-4">
                  By {announcement.AnnouncedBy} on{" "}
                  {announcement.AnnouncedAt.toDate().toLocaleString()}
                </p>

                <p className="text-base sm:text-lg text-white leading-relaxed">
                  {announcement.content}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center p-6 sm:p-10 bg-white dark:bg-gray-800 rounded-lg shadow-md">
            <p className="text-base sm:text-xl font-medium text-black dark:text-white">
              No announcements yet. Check back soon!
            </p>
          </div>
        )
      }
    </div>
  );
};

const Homepage = () =>
{
  return (
    <div className="container mx-auto mt-1 sm:mt-6 px-1 sm:px-4 mb-1">
      <div className="w-full">
        <Announcements />
      </div>
    </div>
  );
};

export default Homepage;